import { Storage } from "@capacitor/storage";
import { Sesion } from "src/utils";

export default {
  async setSesion(sesion: Sesion) {
    await Storage.set({
      key: "token",
      value: sesion.token,
    });
  },

  async getSesion() {
    const token = await Storage.get({ key: "token" });

    if (token.value) return { token: token.value } as Sesion;
    else return undefined;
  },

  async removeSesion() {
    await Storage.remove({ key: "token" });
  },
};
